export { default, Detached } from './ActivityTab';
